import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Checkbox } from "./ui/checkbox";
import { ChevronDown, ShieldCheck } from "lucide-react";

export const CONSENSI_KEYS = ["servizio", "statistico", "marketing"];

export const InformativaText = ({ info }) => (
  <div className="space-y-3 text-xs leading-relaxed" data-testid="informativa-text">
    <p><b>Titolare del trattamento:</b> {info.titolare}</p>
    {info.sezioni.map((s) => (
      <div key={s.titolo}>
        <div className="font-semibold">{s.titolo}</div>
        {s.testo.split("\n").map((t, i) => <p key={i} className="mt-0.5">{t}</p>)}
      </div>
    ))}
    <p className="text-muted-foreground">Versione {info.versione} del {info.data_versione}</p>
  </div>
);

export const ConsensiPrivacy = ({ value, onChange }) => {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(false);
  const [open, setOpen] = useState(false);
  const fetchInfo = () => { setErr(false); api.get("/public/privacy").then((r) => setInfo(r.data)).catch(() => setErr(true)); };
  useEffect(fetchInfo, []);
  if (err) return (
    <div className="mt-5 rounded-lg border border-destructive/40 p-4 text-xs" data-testid="consensi-privacy-error">
      Impossibile caricare l'informativa privacy. <button type="button" className="underline font-semibold" onClick={fetchInfo} data-testid="consensi-privacy-retry">Riprova</button>
    </div>
  );
  if (!info) return null;
  return (
    <div className="mt-5 rounded-lg border border-border p-4 bg-secondary/30" data-testid="consensi-privacy">
      <button type="button" onClick={() => setOpen(!open)} className="flex w-full items-center justify-between text-sm font-semibold" data-testid="informativa-toggle">
        <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-primary" /> Informativa sul trattamento dei dati personali</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-3 max-h-64 overflow-y-auto rounded border border-border bg-background p-3"><InformativaText info={info} /></div>}
      <div className="mt-3 space-y-2.5">
        {CONSENSI_KEYS.map((k) => (
          <label key={k} className="flex items-start gap-2 text-xs text-muted-foreground cursor-pointer">
            <Checkbox checked={!!value[k]} onCheckedChange={(v) => onChange({ ...value, [k]: !!v })} data-testid={`consenso-${k}`} className="mt-0.5" />
            <span>{info.consensi[k]} <span className="text-destructive">*</span></span>
          </label>
        ))}
      </div>
      <p className="mt-2 text-[10px] text-muted-foreground">* Consensi obbligatori per proseguire.</p>
    </div>
  );
};
